var _style;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendAni(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n@keyframes a0_t { 0% { transform: translate(0px,0px); animation-timing-function: cubic-bezier(0.035,0.75,0.5,0.5); } 11.1111% { transform: translate(-2.130808px,0px); animation-timing-function: cubic-bezier(0,0.5,0.5,0.925); } 55.5555% { transform: translate(24.243859px,0.000001px); } 61.1111% { transform: translate(24.243859px,0.000001px); } 66.6666% { transform: translate(-25.349985px,0.000001px); } 77.7777% { transform: translate(-0.000025px,0.000034px); } 100% { transform: translate(-0.000025px,0.000034px); } }\n@keyframes a0_v { 0% { visibility: visible; animation-timing-function: steps(1); } 61.1111% { visibility: hidden; animation-timing-function: steps(1); } 66.6667% { visibility: visible; animation-timing-function: steps(1); } 100% { visibility: visible; animation-timing-function: steps(1); } }\n@keyframes a1_v { 0% { visibility: hidden; animation-timing-function: steps(1); } 33.3333% { visibility: visible; animation-timing-function: steps(1); } 38.8889% { visibility: visible; animation-timing-function: steps(1); } 100% { visibility: visible; animation-timing-function: steps(1); } }\n@keyframes a1_da { 0% { stroke-dasharray: 46px; } 55.5556% { stroke-dasharray: 46px; } 100% { stroke-dasharray: 46px; } }\n@keyframes a1_do { 0% { stroke-dashoffset: 0px; } 27.7778% { stroke-dashoffset: 0px; } 33.3333% { stroke-dashoffset: 0px; } 55.5556% { stroke-dashoffset: 45px; } 100% { stroke-dashoffset: 45px; } }\n@keyframes a2_v { 0% { visibility: hidden; animation-timing-function: steps(1); } 11.1111% { visibility: visible; animation-timing-function: steps(1); } 33.3333% { visibility: hidden; animation-timing-function: steps(1); } 100% { visibility: hidden; animation-timing-function: steps(1); } }\n@keyframes a2_da { 0% { stroke-dasharray: 46px; } 55.5556% { stroke-dasharray: 46px; } 100% { stroke-dasharray: 46px; } }\n@keyframes a2_do { 0% { stroke-dashoffset: 46px; } 11.1111% { stroke-dashoffset: 46px; } 33.3333% { stroke-dashoffset: 0px; } 100% { stroke-dashoffset: 0px; } }\n    ")), /*#__PURE__*/React.createElement("path", {
    stroke: " currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5.73,2.221L21.023,10.377C22.326,11.072,22.326,12.928,21.023,13.623L5.73,21.779C4.495,22.437,3,21.549,3,20.156L3,13.289L16.186,12L3,10.71L3,3.845C3,2.453,4.495,1.565,5.73,2.222Z",
    visibility: "visible",
    transform: "translate(12.5001,12.0008) translate(-12.5001,-12.0008)",
    style: {
      animation: "1.8s linear infinite both a0_t, 1.8s linear infinite forwards a0_v"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2551,-4.16691C7.10269,6.81859,1.52997,-9.09647,7.2921,-9.84907C12.5214,-10.5321,9.47022,5.39805,-3.21989,-2.41492",
    stroke: "currentColor",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    strokeDasharray: 46,
    strokeDashoffset: 0,
    visibility: "hidden",
    transform: "translate(3.17254,17.3779)",
    style: {
      animation: "1.8s linear infinite forwards a1_v, 1.8s linear infinite both a1_da, 1.8s linear infinite both a1_do"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.21989,-2.41492C9.47022,5.39805,12.5214,-10.5321,7.2921,-9.84907C1.52997,-9.09647,7.10269,6.81859,22.2551,-4.16691",
    stroke: "currentColor",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    strokeDasharray: 46,
    strokeDashoffset: 46,
    visibility: "hidden",
    transform: "translate(3.17254,17.3779)",
    style: {
      animation: "1.8s linear infinite forwards a2_v, 1.8s linear infinite both a2_da, 1.8s linear infinite both a2_do"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendAni);
export default __webpack_public_path__ + "static/media/send_ani.ce3df9d8c76455ea4350c90742c3e137.svg";
export { ForwardRef as ReactComponent };